/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface XpMultiplier
 */
export interface XpMultiplier {
    /**
     * 
     * @type {string}
     * @memberof XpMultiplier
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof XpMultiplier
     */
    amount: number;
    /**
     * 
     * @type {number}
     * @memberof XpMultiplier
     */
    createdAt: number;
    /**
     * 
     * @type {number}
     * @memberof XpMultiplier
     */
    expiresAt: number;
}

/**
 * Check if a given object implements the XpMultiplier interface.
 */
export function instanceOfXpMultiplier(value: object): value is XpMultiplier {
    if (!('amount' in value) || value['amount'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('expiresAt' in value) || value['expiresAt'] === undefined) return false;
    return true;
}

export function XpMultiplierFromJSON(json: any): XpMultiplier {
    return XpMultiplierFromJSONTyped(json, false);
}

export function XpMultiplierFromJSONTyped(json: any, ignoreDiscriminator: boolean): XpMultiplier {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'amount': json['amount'],
        'createdAt': json['createdAt'],
        'expiresAt': json['expiresAt'],
    };
}

export function XpMultiplierToJSON(json: any): XpMultiplier {
    return XpMultiplierToJSONTyped(json, false);
}

export function XpMultiplierToJSONTyped(value?: XpMultiplier | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'amount': value['amount'],
        'createdAt': value['createdAt'],
        'expiresAt': value['expiresAt'],
    };
}

